import { OmcareRestClient } from '../generated';
import { restHost } from '../apiConfig';
import { getCookie, deleteToken } from '../shared/utils';
import {
  apiV1Enabled,
  apiVersionedUrl,
  applyVersionHeaders,
} from './apiVersioning';
import { version as appVersion } from '../../package.json';
import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';

// Create the client instance with server and authentication details
const restClient = new OmcareRestClient({
  BASE: `https://${restHost}`,
  TOKEN: getCookie('access_token'),
});

// OI-1411 / OI-1667: single cutover point to the /api/v1 mount. The generated
// client and legacy direct-axios thunks all build absolute URLs and run through
// the global axios instance, so versioning the request URL here migrates every
// call at once. Idempotent + host-guarded + allowlist — see apiVersioning.ts.
axios.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  if (config.url && apiV1Enabled) {
    config.url = apiVersionedUrl(config.url, restHost);
  }
  applyVersionHeaders(config.headers, config.url, restHost, appVersion);
  return config;
});

axios.interceptors.response.use(
  (resp) => {
    return resp;
  },
  (err: AxiosError) => {
    try {
      if (
        err.response?.status === 401
        //&& err.response?.config.url?.includes(restHost)
      ) {
        deleteToken();
      }
      // Requests from the generated OmcareRestClient always carry a
      // cancelToken (src/generated/core/request.ts) and need the rejection to
      // reach it so it can build an ApiError from the response body. Legacy
      // direct-axios thunks instead inspect the RESOLVED AxiosError (e.g. the
      // login flow's `res.response` branches), so only generated-client
      // requests re-throw here.
      if (err.config?.cancelToken) {
        return Promise.reject(err);
      }
      return err;
    } catch (iErr) {
      console.error(iErr);
      return err;
    }
  },
);

export default restClient;
